<template>
  <div v-loading="loading" element-loading-text="拼命加载中" class="main-frame">
    <el-container>
      <el-header class="banner-head">
        <div class="head-info">
          <el-row>
            <el-col style="text-align: left" :span="12">
              <el-page-header
                style="color: #333333"
                :title="$t('commonInfo.Back')"
                @back="goBack"
                content="添加评分标准"
              ></el-page-header>
            </el-col>
            <el-col :span="12" style="text-align: right">
              <el-button @click="get_score_stard" type="primary"
                >查询</el-button
              >
              <el-button @click="add_score_stard" type="primary"
                >添加</el-button
              >
            </el-col>
          </el-row>
        </div>
      </el-header>
      <el-main>
        <!-- 点击添加时弹出框 -->
        <el-dialog
          title="添加评分标准"
          :visible.sync="dialogVisible"
          width="25%"
        >
          <div style="margin-top: 30px">
            <el-form ref="form" :model="form" label-width="140px">
              <el-form-item label="国家：">
                <el-select
                  v-model="form.country_id"
                  @change="get_country_info($event)"
                  placeholder="请选择国家"
                >
                  <el-option
                    :label="item.name"
                    :value="item.id"
                    :key="item.id"
                    v-for="item in form.country_list"
                  ></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="面积权重：">
                <el-input-number
                  v-model="form.area_score_weight"
                  :step="0.1"
                  :max="1"
                  :min="0"
                  label="营业额权重"
                ></el-input-number>
              </el-form-item>

              <el-form-item label="营业额权重：">
                <el-input-number
                  v-model="form.turnover_score_weight"
                  :step="0.1"
                  :max="1"
                  :min="0"
                  label="营业额权重"
                ></el-input-number>
              </el-form-item>
              <el-form-item label="SMOK营业额权重：">
                <el-input-number
                  v-model="form.smok_turnover_score_weight"
                  :step="0.1"
                  :max="1"
                  :min="0"
                  label="SMOK营业额权重："
                ></el-input-number>
              </el-form-item>
              <el-form-item label="shop-mall加分项：">
                <el-input-number
                  v-model="form.extra_shop_mall_score"
                  :step="5"
                  :min="0"
                  label="shop-mall加分项："
                ></el-input-number>
              </el-form-item>
              <el-form-item label="黄金区加分项：">
                <el-input-number
                  v-model="form.extra_golden_business_zone_score"
                  :step="5"
                  :min="0"
                  label="黄金区加分项："
                ></el-input-number>
              </el-form-item>
            </el-form>
            <p style="color: red">
              * 营业额权重,SMOK营业额权重,shop-mall加分项三者之和为1
            </p>
          </div>
          <span slot="footer" class="dialog-footer">
            <el-button @click="dialogVisible = false">取 消</el-button>
            <el-button type="primary" @click="submit_score_standard"
              >提交</el-button
            >
          </span>
        </el-dialog>
        <!-- 表格渲染 -->
        <el-table
          :data="score_stard_list"
          style="width: 100%; margin-top: 20px"
          strip
          border
          default-expand-all
        >
          <el-table-column label="#" width="180" align="center">
            <template slot-scope="scope">
              <p style="font-weight: bold">{{ scope.$index + 1 }}</p>
            </template>
          </el-table-column>
          <el-table-column
            prop="country_name"
            label="国家"
            width="180"
            align="center"
          >
          </el-table-column>
          <el-table-column
            prop="area_score_weight"
            label="面积权重"
            width="180"
            align="center"
          >
          </el-table-column>
          <el-table-column
            prop="turnover_score_weight"
            label="营业额权重"
            align="center"
          >
          </el-table-column>
          <el-table-column
            prop="smok_turnover_score_weight"
            label="smok营业额权重"
            align="center"
          >
          </el-table-column>
          <el-table-column
            prop="extra_shop_mall_score"
            label="shop-mall加分项"
            align="center"
          >
          </el-table-column>
          <el-table-column
            prop="extra_golden_business_zone_score"
            label="黄金区加分项"
            align="center"
          >
          </el-table-column>
          <el-table-column label="操作" align="center">
            <template slot-scope="scope">
              <el-button
                size="small"
                type="primary"
                @click="edit_model(scope.row)"
              >
                编辑
              </el-button>
              <el-button
                size="small"
                type="primary"
                @click="remove_stard(scope.row)"
              >
                删除
              </el-button>
            </template>
          </el-table-column>
        </el-table>
      </el-main>
    </el-container>
  </div>
</template>

<script>
export default {
  name: "AddStoreInfo",
  data() {
    return {
      loading: false,
      form: {
        country_list: "",
        area_score_weight: "0.3", //面积权重
        turnover_score_weight: "0.2", //营业额权重
        smok_turnover_score_weight: "0.5", //smok营业额权重
        extra_shop_mall_score: false, //shopMall额外加分值
        extra_golden_business_zone_score: false, //黄金商业区额外加分值
        // country_id: "6810843648234618880",
        // country_text: "马来西亚",
        country_id: "",
        // country_text: "",
      },
      score_stard_list: [], //评分标准表格数组
      dialogVisible: false,
      country_list_map: {},
    };
  },
  methods: {
    goBack() {
      this.$router.go(-1);
    },
    add_score_stard() {
      this.dialogVisible = true;
    },
    // 获取国家id信息
    get_country_info(e) {
      this.form.country_id = e;
    },
    // 获取评分标准
    get_score_stard() {
      this.loading = true;
      let _me = this;
      let params = {};
      _me.$common
        .httpGet("/api/grade/admin/find/list")
        .then((res) => {
          if ((res.code = 1000000)) {
            _me.loading = false;

            res.data.forEach((item, index) => {
              item.country_name = _me.$common.get_country_related_info(
                item.country_id
              ).name;
            });
            _me.score_stard_list = res.data;
          }
        })
        .catch((err) => {
          _me.loading = false;
          if (err.code == 1000009 || err.code == 1000007) {
            this.$router.push("sign-in");
          }
          if (err && err.message) {
            _me.$message.error(err.message);
          }
        });
    },
    // // 获取国家列表
    // get_country_list() {
    //   this.form.country_list = this.$common.get_address_list_info();
    // },
    // 添加评分标准
    submit_score_standard() {
      this.loading = true;

      let _me = this;
      let params = {
        country_id: this.form.country_id,
        area_score_weight: this.form.area_score_weight,
        turnover_score_weight: this.form.turnover_score_weight,
        smok_turnover_score_weight: this.form.smok_turnover_score_weight,
        extra_shop_mall_score: this.form.extra_shop_mall_score,
        extra_golden_business_zone_score:
          this.form.extra_golden_business_zone_score,
      };
      let total_weight =
        params.area_score_weight +
        params.turnover_score_weight +
        params.smok_turnover_score_weight;
      if (total_weight == 1) {
        _me.$common
          .httpPost("/api/grade/admin/add/one", params)
          .then((res) => {
            _me.loading = false;
            if ((res.code = 1000000)) {
              this.dialogVisible = false;
              _me.$message.success("添加成功");
              this.get_score_stard();
            }
          })
          .catch((err) => {
            _me.loading = false;
            if (err.code == 1000009 || err.code == 1000007) {
              this.$router.push("sign-in");
            }
            if (err && err.message) {
              _me.$message.error(err.message);
            }
          });
      } else {
        _me.$message.error("请重新选择面积权重，营业额权重，smok营业额权重");
      }
    },
    // 删除评分标准
    remove_stard(scope_params) {
      console.log(scope_params.id);
      this.loading = true;
      let _me = this;
      let params = {
        id: scope_params.id,
      };
      _me
        .$confirm("此操作将永久删除该数据, 是否继续?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        })
        .then(() => {
          _me.remove_stard_item(scope_params);
        })
        .catch(() => {
          // eslint-disable-next-line no-console
          console.log("取消删除");
        });
    },

    remove_stard_item(scope_params) {
      let _me = this;
      _me.loading = true;
      let params = {
        id: scope_params.id,
      };
      this.$common
        .httpPost("/api/grade/admin/delete/one", params)
        .then((res) => {
          _me.loading = false;
          if (res.code == "1000000") {
            _me.$message.success("删除成功");
            _me.get_score_stard();
          } else {
            _me.$message.error(res.message);
          }
        })
        .catch((err) => {
          if (err.code == 1000009 || err.code == 1000007) {
            this.$router.push("sign-in");
          }
          _me.loading = false;
          _me.$message.error(err);
        });
    },
    // 编辑按钮
    edit_model(scope_params) {
      this.$router.push("edit-score-stard-detail?id=" + scope_params.id);
    },

    // 初始化国家列表
    get_country_list_initial() {
      this.$common
        .get_storage_list(
          "country_list",
          "http_get",
          "/api/address/country/find/list"
        )
        .then((res) => {
          console.log(res);
          this.form.country_list = res;
          // 默认给国家赋初值
          // this.form.country_list[0].name = res[0].name;
          // this.form.country_list[0].id = res[0].id;
          // this.form.country_id = res[0].id;
        })
        .catch((err) => {
          console.log(err);
        });
    },
  },
  created() {},
  mounted() {
    // 初始化国家列表
    this.get_country_list_initial();

    // 获取评分标准
    this.get_score_stard();
    // 获取国家地区列表
    // this.get_country_list();
  },
};
</script>

<style scoped>
</style>
